export default function (el, props) {
    if (props?.onInit) props.onInit(el);
    const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
            if (props?.onResizing) props.onResizing(entry.contentRect);
        });
    });
    if (el) observer.observe(el);
}
